import axios from "axios";
import { supabase } from "../supabaseClient";


async function getNationality() {
    let query = supabase.from('Nationality').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}

async function addNationality(nationality) {
    const { data, error } = await supabase.from('Nationality')
        .insert([{ nationality: nationality.replace(/\s+/g, '') }])
    if (data) return data
    else throw error;
}
async function updateNationality(nationalityId, nationality) {
    const { data, error } = await supabase
        .from('Nationality')
        .update({ nationality: nationality.replace(/\s+/g, ''), last_updated_at: Date.now() })
        .eq('nationalityId', nationalityId);
    if (data) return data;
    else throw error;
}
async function deleteNationality(nationalityId) {
    let query = await supabase
        .from('Nationality')
        .delete()
        .eq("nationalityId", nationalityId);

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function getWorksIn() {
    let query = supabase.from('Professions').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function addWorksIn(profession) {
    const { data, error } = await supabase.from('Professions')
        .insert([{ profession: profession.replace(/\s+/g, '') }])
    if (data) return data
    else throw error;
}
async function updateWorksIn(professionId, profession) {
    const { data, error } = await supabase
        .from('Professions')
        .update({ profession: profession.replace(/\s+/g, ''), last_updated_at: Date.now() })
        .eq('professionId', professionId);
    if (data) return data;
    else throw error;
}
async function deleteWorksIn(professionId) {
    let query = await supabase
        .from('Professions')
        .delete()
        .eq("professionId", professionId);

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getNative() {
    let query = supabase.from('Native').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function addNative(native) {
    const { data, error } = await supabase.from('Native')
        .insert([{ native: native }])
    if (data) return data
    else throw error;
}
async function updateNative(nativeId, native) {
    const { data, error } = await supabase
        .from('Native')
        .update({ native: native, last_updated_at: Date.now() })
        .eq('nativeId', nativeId);
    if (data) return data;
    else throw error;
}
async function deleteNative(nativeId) {
    let query = await supabase
        .from('Native')
        .delete()
        .eq("nativeId", nativeId);

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
async function getBudget() {
    let query = supabase.from('Budget').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function addBudget(budget) {
    const { data, error } = await supabase.from('Budget')
        .insert([{ budget: budget }])
    if (data) return data
    else throw error;
}
async function updateBudget(budgetId, budget) {
    const { data, error } = await supabase
        .from('Budget')
        .update({ budget: budget, last_updated_at: Date.now() })
        .eq('budgetId', budgetId);
    if (data) return data;
    else throw error;
}
async function deleteBudget(budgetId) {
    let query = await supabase
        .from('Budget')
        .delete()
        .eq("budgetId", budgetId);

    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

async function duplicatesInNationalities(search) {
    let query = supabase.from('Nationality').select('*', { count: 'exact' }).eq('nationality',  search.replace(/\s+/g, ''))
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function checkDuplicates(type,entries){
if(type==="Nationality"){
    let query = supabase.from('Nationality')
    .select('*', { count: 'exact' })
    .in('nationality', entries)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}else if(type==="Works In"){
    let query = supabase.from('Professions')
    .select('*', { count: 'exact' })
    .in('profession', entries)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;

}else if(type==="Native"){
    let query = supabase.from('Native')
    .select('*', { count: 'exact' })
    .in('native', entries)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}else if(type==="Budget"){
    let query = supabase.from('Budget')
    .select('*', { count: 'exact' })
    .in('budget', entries)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
}
async function duplicatesInNative(search) {
    let query = supabase.from('Native').select('*', { count: 'exact' }).eq('native',  search)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function duplicatesInBudget(search) {
    let query = supabase.from('Budget').select('*', { count: 'exact' }).eq('budget',  search)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function duplicatesInWorksIn(search) {
    let query = supabase.from('Professions').select('*', { count: 'exact' }).eq('profession',  search.replace(/\s+/g, ''))
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}

// Get Formated Email

async function getFormatedEmail(type) {
    let query = supabase.from('EmailSmsTemplates').select('*', { count: 'exact' }).eq('type',type)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
// Update Formated Email 
async function updateFormatedEmail(type,emailTemplate,smsTemplate,emailSubject) {
    let query = supabase.from('EmailSmsTemplates').update({'emailTemplate':emailTemplate,'smsTemplate':smsTemplate,'emailSubject':emailSubject}).eq('type',type)
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}


// Blacklisted numbers with owner, from the server (permission-checked there).
// Returns { success, count, data: [{ id, number, blacklistedOn, ownerType, ownerName, linkedTo, ownerStatus }] }
async function getBlacklistNumbersWithOwner({ page, pageSize, search, ownerType, status }) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}settings/blacklist-numbers`;
  const response = await axios.get(url, {
    params: { page, pageSize, search, ownerType, status },
    headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` },
  });
  return response.data;
}

async function getCustomerPaymentMethod(){
    let  query =  supabase
    .from('Settings')
   .select('*')
    const { data, error, count } = await query;
    if (data) return { data, count }
    else throw error;
}
async function updateCustomerPaymentMethod(obj){
    const { data, error, count } = await supabase
    .from('Settings')
   .update(obj)
   .eq('id',1)
    if (data) return { data, count }
    else throw error;
}

async function getAppForSlotBooking(){
    const { data, error } = await supabase
    .from('Settings')
    .select("useInAppForSlotBooking")
    if (data) return { data }
    else throw error;
}

// ---- CP Source mapping (cpSourceMapping) ----
// Master list of Channel Partner source names. cpSourceId is an auto-generated
// identity PK. Names are unique case-insensitively (enforced both here and by a
// DB unique index on lower(sourceName)).
async function getCpSources() {
    const { data, error, count } = await supabase
        .from('cpSourceMapping')
        .select('*', { count: 'exact' })
        .order('sourceName', { ascending: true });
    if (data) return { data, count };
    else throw error;
}

async function addCpSource(sourceName) {
    const { data, error } = await supabase
        .from('cpSourceMapping')
        .insert([{ sourceName: sourceName.trim() }])
        .select();
    if (error) throw error;
    return data;
}

async function updateCpSource(cpSourceId, sourceName) {
    const { data, error } = await supabase
        .from('cpSourceMapping')
        .update({ sourceName: sourceName.trim(), last_updated_at: Date.now() })
        .eq('cpSourceId', cpSourceId)
        .select();
    if (error) throw error;
    return data;
}

async function deleteCpSource(cpSourceId) {
    const { data, error, count } = await supabase
        .from('cpSourceMapping')
        .delete()
        .eq('cpSourceId', cpSourceId);
    if (error) throw error;
    return { data, count };
}

// Case-insensitive existence check. excludeId skips the row being edited so a
// rename to its own (same-case-different) name is not flagged as a duplicate.
async function duplicateCpSource(sourceName, excludeId) {
    let query = supabase
        .from('cpSourceMapping')
        .select('cpSourceId, sourceName', { count: 'exact' })
        .ilike('sourceName', sourceName.trim());
    if (excludeId !== undefined && excludeId !== null) {
        query = query.neq('cpSourceId', excludeId);
    }
    const { data, error, count } = await query;
    if (error) throw error;
    return { data, count };
}

// ---- Customer consents (ConsentTemplates) ----
// At most one consent per type: 'token', 'allotment', 'virtual_account'.
// If a type has a consent, the Customer Portal asks for it before payment / virtual account details.
async function getConsentTemplates() {
    // CRM2 M1-F6: CRM 2.0 terms (type 'crm2:<point>') live in the same table; they are
    // managed in Settings › CRM 2.0 › Customer Consent, not on this screen.
    const { data, error } = await supabase
        .from('ConsentTemplates')
        .select('*')
        .not('type', 'like', 'crm2:%')
        .order('created_at', { ascending: true });
    if (error) throw error;
    return data;
}

async function addConsentTemplate(obj) {
    const { data, error } = await supabase.from('ConsentTemplates').insert([obj]);
    if (error) throw error;
    return data;
}

async function updateConsentTemplate(consentTemplateId, obj) {
    const { data, error } = await supabase
        .from('ConsentTemplates')
        .update({ ...obj, updated_at: new Date().toISOString() })
        .eq('consentTemplateId', consentTemplateId);
    if (error) throw error;
    return data;
}

async function deleteConsentTemplate(consentTemplateId) {
    const { data, error } = await supabase
        .from('ConsentTemplates')
        .delete()
        .eq('consentTemplateId', consentTemplateId);
    if (error) throw error;
    return data;
}

export {
    getNationality, getNative, getWorksIn, addNationality, updateNationality, deleteNationality,
    addWorksIn, updateWorksIn, deleteWorksIn, addNative, updateNative, deleteNative,duplicatesInNationalities,
    getBudget, addBudget, updateBudget, deleteBudget, duplicatesInBudget,
    duplicatesInWorksIn,duplicatesInNative,updateFormatedEmail,getFormatedEmail,checkDuplicates,
    getBlacklistNumbersWithOwner,getCustomerPaymentMethod,updateCustomerPaymentMethod,getAppForSlotBooking,
    getCpSources, addCpSource, updateCpSource, deleteCpSource, duplicateCpSource,
    getConsentTemplates, addConsentTemplate, updateConsentTemplate, deleteConsentTemplate
};